import compose from "recompose/compose";
import withState from "recompose/withState";
import withProps from "recompose/withProps";
import withHandlers from "recompose/withHandlers";
import setOptionHandler from "./utils/setOptionHandler";
import computeUpdatedPricesForProduct from "./computeUpdatedPrices";

export const fusePriceWithBundleOptions = (
  product,
  selectedBundleOptions,
  getPrice
) => {
  const productPrice = getPrice(product.prices);
  if (productPrice === undefined || productPrice === null) {
    return null;
  }

  return product.bundleOptions.reduce((acc, option) => {
    let selectedValue;
    if (selectedBundleOptions[option.id]?.values?.length > 0) {
      const selectedBundledProducts = option.values.filter(({ value }) =>
        selectedBundleOptions[option.id].values.includes(value)
      );
      if (selectedBundledProducts.length > 0) {
        selectedValue = selectedBundledProducts
          .map((selectedBundledProduct) => {
            const optionValuePrice =
              getPrice(selectedBundledProduct.prices) ?? 0;
            return (
              optionValuePrice *
              (selectedBundleOptions[option.id].quantity ?? 1)
            );
          })
          .reduce((acc, value) => acc + value, 0);
      }
    }

    if (!selectedValue) {
      if (option.required && option.values.length > 0) {
        selectedValue = Math.min(
          ...option.values.map(
            (bundledProduct) => getPrice(bundledProduct.prices) ?? 0
          )
        );
      } else {
        selectedValue = 0;
      }
    }

    return acc + selectedValue;
  }, getPrice(product.prices));
};

const withSelectedBundleOptions = () =>
  compose(
    withState(
      "selectedBundleOptions",
      "setSelectedBundleOptions",
      (props) => props.selectedBundleOptions ?? {}
    ),
    withHandlers({
      setBundleOption: setOptionHandler("setSelectedBundleOptions"),
    }),
    withProps((props) => {
      if (
        !props.product.bundleOptions ||
        props.product.bundleOptions.length === 0
      ) {
        return {};
      }

      const prices = computeUpdatedPricesForProduct(
        props.product,
        props.selectedBundleOptions,
        fusePriceWithBundleOptions
      );

      return {
        product: {
          ...props.product,
          prices,
        },
      };
    })
  );

export default withSelectedBundleOptions;
